// extracted by mini-css-extract-plugin
module.exports = {"overlay":"loading_overlay__jXfKU","fadeIn":"loading_fadeIn__5eRHF","spinner":"loading_spinner__zvaOW","spin":"loading_spin__xnAfU"};